import {
  auth_url,
  back_office_axi,
  payment_axi,
} from "../context/authContext";

export const signupLandlord = async (data) => {
  const response = await auth_url.post("/passport/landlord-sign-up", data);
  return response.data;
};

export const loginProvider = async (data) => {
  const response = await auth_url.post("/passport/login", data);
  return response.data;
};

export const createClient = async (data) => {
  const response = await back_office_axi.post(
    "/api/clients/create-client",
    JSON.stringify(data),
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  return response.data;
};

export const getClientProfileByUserId = async (userId) => {
  const response = await back_office_axi.get(
    `/api/client/get-client-profile/${userId}`,
  );
  return response.data;
};

export const getClientProfileByEmail = async (email) => {
  if (!email?.trim()) {
    throw { message: "Email is required to fetch client profile." };
  }

  const response = await back_office_axi.get(
    `/api/clients/get-client-profile-by-email?email=${encodeURIComponent(email.trim().toLowerCase())}`,
  );
  return response.data;
};

export const createClientWallet = async (data) => {
  const response = await payment_axi.post(
    "/api/accounts/create-client-account",
    data,
  );
  return response.data;
};

export const createWithdrawalAccount = async (data) => {
  const response = await payment_axi.post(
    "/api/accounts/create-withdrawal-account",
    data,
  );
  return response.data;
};

export const createClientLicense = async (data) => {
  const response = await back_office_axi.post(
    "/api/licenses/create-license",
    JSON.stringify(data),
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  return response.data;
};

export const createStarterPurchaseOrder = async (data) => {
  const response = await payment_axi.post("/api/payments/create-po", data);
  return response.data;
};
